import { useEffect } from 'react';
import { goToStation } from '@/lib/navigation';
import { stations, useTourStore } from '@/state/tour';

const VH_PER_STATION = 1.6;

export function ScrollTrack() {
  const setProgress = useTourStore((s) => s.setProgress);
  const height = `${Math.round(stations.length * VH_PER_STATION * 100)}vh`;

  useEffect(() => {
    const onScroll = () => {
      const max = document.documentElement.scrollHeight - window.innerHeight;
      setProgress(max > 0 ? window.scrollY / max : 0);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    return () => {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
    };
  }, [setProgress]);

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'ArrowRight' || e.key === 'PageDown') {
        e.preventDefault();
        goToStation(useTourStore.getState().activeIndex + 1);
      } else if (e.key === 'ArrowLeft' || e.key === 'PageUp') {
        e.preventDefault();
        goToStation(useTourStore.getState().activeIndex - 1);
      }
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, []);

  return <div className="scroll-track" style={{ height }} aria-hidden />;
}
